import type { Severity, ValidationIssue } from '../../../core/issues.js';

import { toPointer } from '../../../core/issues.js';

export type ShapeIssueFactory = (
  code: string,
  message: string,
  path: (string | number)[],
  nodeId: unknown,
  currentValue?: unknown,
  severity?: Severity,
) => ValidationIssue;

/** Issue factory for a shape rule: every issue it emits carries the same `constraint.detail`. */
export const shapeIssue = (detail: string): ShapeIssueFactory =>
  (code, message, path, nodeId, currentValue, severity = 'error') => ({
    code,
    severity,
    message,
    path,
    pointer: toPointer(path),
    locator: { ...(typeof nodeId === 'string' ? { nodeId } : {}) },
    currentValue,
    constraint: { kind: 'shape', detail },
  });

export const isNonEmptyString = (v: unknown): v is string =>
  typeof v === 'string' && v.trim().length > 0;

export const isRecord = (v: unknown): v is Record<string, unknown> =>
  typeof v === 'object' && v !== null && !Array.isArray(v);
